// extracted by mini-css-extract-plugin
export default {"uploadPartnersContainer":"styles_uploadPartnersContainer__Rq2My","uploadButton":"styles_uploadButton__Il4Ve","downloadButton":"styles_downloadButton__oCEoi"};